import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-449451c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModalMarkAllAsRead",
  tabindex: "1",
  "aria-labelledby": "confirmModalMarkAllAsRead",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog--small" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header mb-3" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "text-center fs-6 mb-4" }
const _hoisted_8 = { class: "d-flex justify-content-center modal-footer button-container" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import userService from '@/services/auth.service'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { useRoute } from 'vue-router'
import { useToast } from 'vue-toastification'
import { ref, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  activeCommunityNotification: {
    type: Boolean,
    default: true,
  },
  fromAdminSite: {
    type: Boolean,
    default: false,
  },
},
  emits: ['afterMarkAsRead'],
  setup(__props, { emit }) {

const props = __props

const route = useRoute()
const toast = useToast()
const loading = ref(false)




const markAsReadNotification = async () => {
  loading.value = true
  const { fromAdminSite } = props
  try {
    const markAsReadApi = props.activeCommunityNotification
      ? () => userService.markAsReadCommunityNotificationsApi(route.params?.id as string, fromAdminSite)
      : () => userService.markAsReadNotificationsApi(fromAdminSite)

    const response = await markAsReadApi()
    if (response?.status === 200) {
      emit('afterMarkAsRead')
    } else {
      showErrorToast('markAsReadNotificationFailed')
    }
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}

const showErrorToast = (messageCode) => {
  toast.error({
    component: ErrorToast,
    props: { messageCode },
  })
}

const contentText = computed(() => {
  const type = props.activeCommunityNotification ? translate('community') : 'YELLoop'
  return translate('modalMarkAllNotificationsAsReadContent', type)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('modalMarkAllNotificationsAsReadTitle')), 1),
          _hoisted_6
        ]),
        _createElementVNode("h4", _hoisted_7, _toDisplayString(_unref(contentText)), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            type: 'secondary',
            "data-bs-dismiss": "modal"
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: _unref(translate)('markAsRead'),
            type: 'secondary',
            onClick: markAsReadNotification,
            disabled: loading.value,
            loading: loading.value
          }, null, 8, ["title", "disabled", "loading"])
        ])
      ])
    ])
  ]))
}
}

})